import { connect } from 'react-redux';
import { resetZoomEvent } from 'actions/EventActions';

import ZoomEventDetailsModule from './ZoomEventDetailsModule';

const mapDispatch = dispatch => ({
  handleResetMeeting: () => dispatch(resetZoomEvent()),
});

export default connect(null, mapDispatch)(ZoomEventDetailsModule);



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomEventDetailsModule/index.js